import type { FunctionComponent } from "react";
import { useSocialApproveAdminHttp } from "../../../hooks/http/admin/socials/social-approve.admin.http";
import type { ISocial } from "../../../types/models/social.models.types";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError, useHandleNavigate } from "../../../utils/utils";

type AppProps = {
	removeById: (id: string) => void;
	social: ISocial;
	className?: string;
};

export const ApproveButton: FunctionComponent<AppProps> = ({
	social,
	removeById,
	className,
}) => {
	const { execute: approveSocialsHttp, fetching: fetchingApprove } =
		useSocialApproveAdminHttp();

	const { toast } = useToast();
	const { handleNavigate } = useHandleNavigate("/admin/socials");

	const handleApprove = async () => {
		const response = await approveSocialsHttp({
			pathParams: { id: social.id },
			body: null,
		});

		if (!response.success) {
			return handleHttpError(response, toast);
		}
		removeById(social.id);

		handleNavigate();
	};

	if (social.applicationStatus.status === "applied") {
		return (
			<Button
				disabled={fetchingApprove}
				onClick={handleApprove}
				className={`border-approvebuttonborder bg-approvebuttonbg border font-semibold text-approvebuttontext tracking-wider ${className}`}
			>
				Approve
			</Button>
		);
	}

	if (social.applicationStatus.status === "rejected") {
		return (
			<Button
				disabled={fetchingApprove}
				onClick={handleApprove}
				className={`border-approvebuttonborder bg-approvebuttonbg border font-semibold text-approvebuttontext tracking-wider ${className}`}
			>
				Change to Approved
			</Button>
		);
	}

	return (
		<Button
			className={`border-approvebuttonborder bg-approvebuttonbg border font-semibold text-approvebuttontext tracking-wider ${className}`}
		>
			Approved
		</Button>
	);
};
